/**
 * Builds a URL path for navigating to a feature with optional hierarchyId
 * Pattern: /:featureName/hierarchyId/:hierarchyId or /:featureName
 *
 * @param featureName - The name of the feature to navigate to
 * @param hierarchyId - Optional hierarchyId to include in the path
 * @returns The constructed URL path
 */
export const buildFeatureUrl = (featureName: string, hierarchyId?: string | null): string => {
  if (hierarchyId) {
    return `/${featureName}/hierarchyId/${hierarchyId}`
  }
  return `/${featureName}`
}
